import { useCallback } from 'react';

export const useUpdateSoundInfo = () => {
	const updateSoundInfo = useCallback((newData, prevData) => {
		const newSound = { ...prevData.sound };

		const mode = newData.hud.mode;

		const light = newData.hud.traffic_light;
		const prevLight = prevData.hud.traffic_light;
		const prevMode = prevData.hud.mode;

		const isSpecialMode = newData.hud.mode_indicator !== 'UNKNOWN';

		newSound.method = '';
		newSound.sound_list = [];

		let updatedWelcome = { ...newData.welcome };

		if (mode === 'AUTONOMOUS' && prevMode === 'MANUAL') {
			newSound.sound_list.push('start_ad');
			if (updatedWelcome.introduction) {
				updatedWelcome.introduction = false;
				newSound.sound_list.push('introduction');
			}
		}
		if (mode === 'MANUAL' && prevMode === 'AUTONOMOUS') {
			newSound.sound_list.push('end_ad');
		}

		if (mode === 'AUTONOMOUS' && !isSpecialMode) {
			if (light !== '' && prevLight === '') {
				newSound.sound_list.push('traffic_front');
			}

			if (light === 'RED' && prevLight !== 'RED') {
				newSound.sound_list.push('traffic_red');
			}

			if (light === 'GREEN' && prevLight !== 'GREEN') {
				newSound.sound_list.push('traffic_green');
			}

			if (light === 'UNKNOWN' && prevLight !== 'UNKNOWN') {
				newSound.sound_list.push('traffic_warning');
			}

			if (light !== '' && prevLight === '') {
				newSound.sound_list.push('traffic_check');
			}
		}

		if (newSound.sound_list.length !== 0) {
			newSound.method = 'stop&play';
		}

		return {
			newSound,
			updatedWelcome,
		};
	}, []);

	return { updateSoundInfo };
};
